import React, { useEffect, useState } from "react";
import { useLevel } from "Trackalyze/context/LevelContext";

const Scrim = React.forwardRef(({
  animate: propsAnimate,
  zIndex,
  className,
  transparent,
  onClick,
  children,
  ...rest
}, ref) => {
  const [animate, setAnimate] = useState(false);
  const contextLevel = useLevel();

  // Use prop if provided, otherwise use context.
  // We remove the +1 offset to make z-index explicit and predictable.
  // If caller wants 2400, they pass 2400.
  const finalLevel = zIndex !== undefined ? zIndex : contextLevel;

  const classes = [
    "ta-scrim",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  useEffect(() => {
    if (propsAnimate !== animate && propsAnimate === false) {
      setAnimate(false);
      window.setTimeout(() => {
        onClick && onClick();
      }, 100);
    } else if (propsAnimate === true) {
      setAnimate(true);
    }
  }, [propsAnimate]);

  return (
    <div
      ref={ref}
      className={classes}
      data-transparent={transparent ? "true" : undefined}
      data-animate={animate ? "true" : undefined}
      onClick={(event) => {
        event.stopPropagation();
        onClick && onClick();
      }}
      style={{ zIndex: finalLevel }}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Scrim;
